"use client";
import LinkUrl from '@/projectRoot/src/components/common/general/link/LinkUrl';
import style from './headerMenu.module.scss';
import HeaderSubmenu from '../header-submenu/HeaderSubmenu';
import Chevron from '@/projectRoot/src/components/common/svg/Chevron';
import { useEffect, useState } from 'react';
import Heart from '@/projectRoot/src/components/common/svg/Heart';
import MenuItemDto from '@/projectRoot/api-client/interfaces/models/content/menu/MenuItem.dto';
import { Language, locales } from '@/projectRoot/routes.config';
import { routeUrl } from '@/projectRoot/src/utils/handlers/urlHandler';
import { useLocale, useTranslations } from 'next-intl';
import { translationsHandler } from '@/projectRoot/src/utils/handlers/translationsHandler';
import { useParams, usePathname, useSearchParams } from 'next/navigation';

interface Props {
    menu_items: MenuItemDto[];
    multilang_slugs?: Record<Language, string>;
    route_parameter?: {
        list?: string;
        single?: string;
    }
    classes?: string[];
    onHoverItem?: (hovered: boolean) => void;
    isHovered?: boolean;
}

const HeaderMenu = ({menu_items, classes = [], onHoverItem, isHovered, multilang_slugs, route_parameter}: Props) => {
    const currentLang = useLocale();
    const params = useParams();
    const pathname = usePathname();
    const query = useSearchParams();
    const t = useTranslations();

    const menuItems = [
        {
            title: 'New',
            url: '/',
            order: 0,
            submenu: [
                {
                    title: 'New 1',
                    url: '/',
                    order: 0
                },
                {
                    title: 'New 2',
                    url: '/',
                    order: 1
                },
                {
                    title: 'New 3',
                    url: '/',
                    order: 2
                },
                {
                    title: 'New 4',
                    url: '/',
                    order: 3
                },
                {
                    title: 'New 5',
                    url: '/',
                    order: 4
                },
                {
                    title: 'New 6',
                    url: '/',
                    order: 5
                },
                {
                    title: 'New 7',
                    url: '/',
                    order: 6
                },
            ],
            promo_1: {
                img_src: '',
                title: 'Nude',
                url: '/',
                url_text: 'Shop Now'
            },
            promo_2: {
                img_src: '',
                title: 'Lady B Cream',
                url: '/',
                url_text: 'Shop Now'
            },
            promo_3: {
                img_src: '',
                title: 'Nude 2.0',
                url: '/',
                url_text: 'Shop Now'
            },
        },
        {
            title: 'FIR',
            url: '/',
            order: 1,
            submenu: [
                {
                    title: 'Fir 1',
                    url: '/',
                    order: 0
                },
                {
                    title: 'Fir 2',
                    url: '/',
                    order: 1
                },
                {
                    title: 'Fir 3',
                    url: '/',
                    order: 2
                },
                {
                    title: 'Fir 4',
                    url: '/',
                    order: 3
                },
                {
                    title: 'Fir 5',
                    url: '/',
                    order: 4
                },
                {
                    title: 'Fir 6',
                    url: '/',
                    order: 5
                },
                {
                    title: 'Fir 7',
                    url: '/',
                    order: 6
                },
            ]
        },
        {
            title: 'Beachwear',
            url: '/',
            order: 2,
            submenu: [
                {
                    title: 'Beachwear 1',
                    url: '/',
                    order: 0
                },
                {
                    title: 'Beachwear 2',
                    url: '/',
                    order: 1
                },
                {
                    title: 'Beachwear 3',
                    url: '/',
                    order: 2
                },
                {
                    title: 'Beachwear 4',
                    url: '/',
                    order: 3
                },
                {
                    title: 'Beachwear 5',
                    url: '/',
                    order: 4
                },
                {
                    title: 'Beachwear 6',
                    url: '/',
                    order: 5
                },
                {
                    title: 'Beachwear 7',
                    url: '/',
                    order: 6
                },
            ]
        },
        {
            title: 'Accessories',
            url: '/',
            order: 3
        },
        {
            title: 'Tights',
            url: '/',
            order: 4
        },
        {
            title: 'Sleepwear',
            url: '/',
            order: 5,
            submenu: [
                {
                    title: 'Sleepwear 1',
                    url: '/',
                    order: 0
                },
                {
                    title: 'Sleepwear 2',
                    url: '/',
                    order: 1
                },
                {
                    title: 'Sleepwear 3',
                    url: '/',
                    order: 2
                },
                {
                    title: 'Sleepwear 4',
                    url: '/',
                    order: 3
                },
                {
                    title: 'Sleepwear 5',
                    url: '/',
                    order: 4
                },
                {
                    title: 'Sleepwear 6',
                    url: '/',
                    order: 5
                },
                {
                    title: 'Sleepwear 7',
                    url: '/',
                    order: 6
                },
            ]
        },
        {
            title: 'Underwear',
            url: '/',
            order: 6
        },
    ];
    const [showSubmenu, setShowSubmenu] = useState<string>('');

    const onClickShowSubmenu = (id: string) => {
        setShowSubmenu(showSubmenu == id ? '' : id);
    }

    let refinedSlugs: Record<string, string>;

    if(!multilang_slugs){
        refinedSlugs = translationsHandler({
            refinedSlugs: refinedSlugs, 
            pathname: pathname, 
            lang: currentLang, 
            route_parameter: route_parameter ? (Object.keys(params).length > 1 ? route_parameter.single : route_parameter.list) : undefined, 
            params: params as Record<string, string>
        });
    }

    // const getMenus = async () => {
    //     try{
    //         const res = await apiClient.contentMenusItems().search({rows_per_page: 50});
    //         console.log('client: ', res.data)
    //     }catch(err){
    
    //         console.log(err)
    //     }
    // }

    // useEffect(() => {
    //     getMenus();
    // }, [apiClient]);

  return (
    <nav className={`${style.navMenu} ${classes.join(' ')}`}>
        <ul className={style.menu}>
            {
                menu_items.sort((a, b) => a.order - b.order).map((item, index) => 
                    <li className={`${style.menuItem} ${isHovered ? style.hovered : ''}`} key={index} onMouseEnter={() => onHoverItem(true)} onMouseLeave={() => onHoverItem(false)}>
                        <LinkUrl classes={[style.menuLink]} text={item.title} url={item.call_to_action_url} />
                        {
                            item.children && item.children.length > 0
                            ?
                            <>
                                <span className={`${style.chevron} ${item.title + index == showSubmenu ? style.rotated : ''}`} onClick={() => onClickShowSubmenu(item.title + index)}>
                                    <Chevron width={13} height={7} />
                                </span>
                                <HeaderSubmenu classes={[style.submenu, item.title + index == showSubmenu ? style.visible : '']} item={item} />
                            </>
                            : <></>
                        }
                    </li>
                )
            }
        </ul>
        <div className={style.wishlistPart}>
            <Heart width={16} height={16} />
            {t('favorites')}
        </div>
        <div className={style.locales}>
            <p>{t('language')}: </p>
            <div className={style.localesList}>
                {
                    locales.map(locale => {
                        let href: string = routeUrl({
                            lang: locale,
                            multilangslugs: multilang_slugs ? multilang_slugs : refinedSlugs,
                            pathname: !multilang_slugs ? pathname : '',
                            query: !multilang_slugs ? query : [],
                            fake_url: refinedSlugs ? true : false
                        });
                        return (
                            <LinkUrl 
                                text={locale.toLocaleUpperCase()} 
                                url={href} 
                                key={locale} 
                                classes={[`${style.localeLink} ${locale == currentLang ? style.active : ''}`]} 
                            />
                        )
                    })
                }
            </div>
        </div>
    </nav>
  )
};

export default HeaderMenu;
